import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import PropTypes from "prop-types";
import { Input, Label } from "arv-reactcomponents";
import ToolTip from "../../ToolTip";

@inject("CheckoutStore")
@observer
class ApplicablePromosList extends Component {
  constructor(props) {
    super(props);
    this.handleRadioChange = this.handleRadioChange.bind(this);
  }

  handleRadioChange(event) {
    this.props.onPromoChange(event);
  }

  get isChecked() {
    const { promoData, promoName, promoFromSelection } = this.props;
    const { pricingOverviewData: { couponCode } } = this.props.CheckoutStore;
    if (promoName) {
      return promoData.name === promoName && !promoFromSelection;
    }
    return promoData.name === couponCode && !promoFromSelection;
  }

  render() {
    const { promoData } = this.props;
    return (
      <div className="nw-applicable-promo-col">
        <Label
          className="nw-app-promo-radio-label"
          htmlFor={`nw-app-promo-radio-label-${promoData.name}`}
        >
          <Input
            id={`nw-app-promo-radio-label-${promoData.name}`}
            className="nwc-inp-radio-primary nwc-inp-sm"
            type="radio"
            name="applicablepromos"
            value={promoData.name}
            onChange={this.handleRadioChange}
            checked={this.isChecked}
          />
          <span className="nw-app-promo-radio-label-span">
            {promoData.promotionDetails.displayName} ({promoData.name})
          </span>
          <ToolTip.component
            description={promoData.promotionDetails.tnc}
            className="nw-apppromo-tnc"
          />
        </Label>
      </div>
    );
  }
}

ApplicablePromosList.wrappedComponent.propTypes = {
  promoFromSelection: PropTypes.string.isRequired,
  promoName: PropTypes.string.isRequired,
  promoData: PropTypes.shape({}).isRequired,
  onPromoChange: PropTypes.func.isRequired,
  CheckoutStore: PropTypes.shape({
    pricingOverviewData: PropTypes.shape({
      couponCode: PropTypes.string,
    }).isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("CheckoutStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: ApplicablePromosList.wrappedComponent,
  component: ApplicablePromosList,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/Promotions/ApplicablePromosList/index.js